import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import background from "../assets/IndividualBloghero.jpeg"
import { env } from '../config'
import { useLocation, useNavigate, useParams } from 'react-router'
import axios from 'axios'
import * as Actions from "../redux/actions"
import Loader from '../components/Loader'
import { useSearchParams } from "react-router-dom";
import toast from 'react-hot-toast'

function IndividualBlog() {
    let { key }: any = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch()



    const location = useLocation();


    const getBlogContent = () => {
        axios.get(`${env}/api/blogs?populate=deep`)
            .then(function (response) {
                console.log("kkk", response?.data?.data);
                dispatch(Actions.BlogContentAction(response?.data?.data))
            })
    }

    const getBlogData = () => {
        axios.get(`${env}/api/blog-page-content?populate=deep`)
            .then(function (response) {
                console.log("kkkkkkkkkkkk", response?.data?.data);
                dispatch(Actions.BlogPageAction(response?.data?.data?.attributes))
            })
    }



    const BlogPage: any = useSelector((state: any) => state?.Page?.BlogContent)
    const BlogPageContent: any = useSelector((state: any) => state?.Page?.BlogPageContent)

    console.log("aksdkankdjak", BlogPageContent)



    const setBlogpage = () => {
        console.log("Blogpageeinuseffect", decodeURI(location?.pathname?.split("/")[2].split("_").join(" ")))
        let test = BlogPage?.filter((node: any, index: number) => {
            console.log("attributes=>", node?.attributes?.BlogHeader?.MainTitle.toLowerCase(), "decodeURI=>", decodeURI(location?.pathname?.split("/")[2].split("-").join(" ")))
            return node?.attributes?.BlogHeader?.MainTitle.toLowerCase() === decodeURI(location?.pathname?.split("/")[2].split("-").join(" "))
        })
        console.log("testtt", test[0])
        return test[0]
    }




    const switchBlogPage = () => {
        console.log("locationURI", decodeURI(location?.pathname?.split("/")[2].split("_").join(" ")))
        return BlogPage[0]
    }
    const [currentPage, setcurrentPage] = useState(switchBlogPage())






    useEffect(() => {
        if (BlogPage.length === 0) {
            getBlogContent()
        }
        getBlogData()
        console.log("paramnsas", key)
        setcurrentPage(setBlogpage())

        console.log("curerntpagae",)

    }, [BlogPage, key])





    const ChangePage = (index: number, direction: string) => {
        console.log("BlogPage", BlogPage)
        let currentPageIndex = BlogPage?.findIndex((node: any) => {
            return node === currentPage
        })
        console.log("currentPageIndex", currentPageIndex)
        if (direction === "increment") {
            if (currentPageIndex === BlogPage?.length - 1) {
                setcurrentPage(BlogPage[0])
                const nextTitle = BlogPage[0]?.attributes?.BlogHeader?.MainTitle.replace(/\s/g, "-").toLowerCase()
                navigate(`/blog/${nextTitle}`)

            } else {
                setcurrentPage(BlogPage[currentPageIndex + 1])
                console.log("locationkhbkbhj", BlogPage[currentPageIndex + 1], location)
                const nextTitle = BlogPage[currentPageIndex + 1]?.attributes?.BlogHeader?.MainTitle.replace(/\s/g, "-").toLowerCase()
                navigate(`/blog/${nextTitle}`)
            }
        } else {
            if (currentPageIndex === 0) {
                setcurrentPage(BlogPage[BlogPage?.length - 1])
                const nextTitle = BlogPage[BlogPage?.length - 1]?.attributes?.BlogHeader?.MainTitle.replace(/\s/g, "-").toLowerCase()
                navigate(`/blog/${nextTitle}`)
            } else {
                setcurrentPage(BlogPage[currentPageIndex - 1])
                const nextTitle = BlogPage[currentPageIndex - 1]?.attributes?.BlogHeader?.MainTitle.replace(/\s/g, "-").toLowerCase()
                navigate(`/blog/${nextTitle}`)
            }

        }


    }


    const handleSideBarClick = (passedObject: any) => {
        console.log("alduhkajdbfk", passedObject?.attributes?.BlogHeader?.MainTitle)
        let currentPageIndex = BlogPage?.findIndex((node: any) => {
            return node === passedObject
        })
        console.log("currentSlide", currentPageIndex)
        setcurrentPage(BlogPage[currentPageIndex])

        const nextTitle = BlogPage[currentPageIndex]?.attributes?.BlogHeader?.MainTitle.replace(/\s/g, "-").toLowerCase()
        console.log("nexttitle", nextTitle)
        navigate(`/blog/${nextTitle}`)



    }






    return (
        BlogPage.length > 0 ?
            <div>
                <div style={{ backgroundImage: `url(${env}${BlogPageContent?.BlogPageIntro?.individiualHeaderImage?.data?.attributes?.url})` }} className={`px-5 md:px-20 relative  font-custom bg-no-repeat bg-cover text-white h-[150%] md:h-[400px] lg:h-[537px] bg-center flex flex-col justify-center items-center gap-10`}>
                    <div className='h-full   items-start flex-col flex justify-center mr-auto '>
                        <div className=' text-2xl  place-self-start mt-7 md:mt-0 '>
                            Blog
                        </div>
                        <div data-aos="zoom-out" className=' font-custom font-bold text-3xl md:text-4xl xl:text-5xl my-4 '>
                            {currentPage?.attributes?.BlogHeader?.MainTitle}
                        </div>
                        <div className='flex items-center  gap-2'>
                            <svg width="14" height="13" viewBox=" 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.31699 9.51669L10.017 8.81669L7.50033 6.30002V3.16669H6.50033V6.70002L9.31699 9.51669ZM7.00033 12.8334C6.12255 12.8334 5.29766 12.6667 4.52566 12.3334C3.75321 12 3.08366 11.55 2.51699 10.9834C1.95033 10.4167 1.50033 9.74713 1.16699 8.97469C0.833659 8.20269 0.666992 7.3778 0.666992 6.50002C0.666992 5.62224 0.833659 4.79713 1.16699 4.02469C1.50033 3.25269 1.95033 2.58335 2.51699 2.01669C3.08366 1.45002 3.75321 1.00002 4.52566 0.666687C5.29766 0.333354 6.12255 0.166687 7.00033 0.166687C7.8781 0.166687 8.70321 0.333354 9.47566 0.666687C10.2477 1.00002 10.917 1.45002 11.4837 2.01669C12.0503 2.58335 12.5003 3.25269 12.8337 4.02469C13.167 4.79713 13.3337 5.62224 13.3337 6.50002C13.3337 7.3778 13.167 8.20269 12.8337 8.97469C12.5003 9.74713 12.0503 10.4167 11.4837 10.9834C10.917 11.55 10.2477 12 9.47566 12.3334C8.70321 12.6667 7.8781 12.8334 7.00033 12.8334ZM7.00033 11.8334C8.4781 11.8334 9.73655 11.314 10.7757 10.2754C11.8143 9.23624 12.3337 7.9778 12.3337 6.50002C12.3337 5.02224 11.8143 3.7638 10.7757 2.72469C9.73655 1.68602 8.4781 1.16669 7.00033 1.16669C5.52255 1.16669 4.26433 1.68602 3.22566 2.72469C2.18655 3.7638 1.66699 5.02224 1.66699 6.50002C1.66699 7.9778 2.18655 9.23624 3.22566 10.2754C4.26433 11.314 5.52255 11.8334 7.00033 11.8334Z" fill="white" />
                            </svg>
                            {currentPage?.attributes?.BlogHeader?.Date}
                        </div>
                        <div className='flex gap-6 my-4 bg-none'>
                            <button onClick={() => { navigator.clipboard.writeText(currentPage?.attributes?.BlogHeader?.MainTitle); toast?.success("Copied To Clipboard") }} data-aos="flip-up" className='rounded-[50%] border border-white p-3 sm:p-4'>  <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.31289 13.975C1.93789 13.975 1.61914 13.8437 1.35664 13.5812C1.09414 13.3187 0.962891 13 0.962891 12.625V3.09998H2.08789V12.625C2.08789 12.6875 2.10964 12.7405 2.15314 12.784C2.19714 12.828 2.25039 12.85 2.31289 12.85H9.58789V13.975H2.31289ZM4.93789 11.35C4.56289 11.35 4.24414 11.2187 3.98164 10.9562C3.71914 10.6937 3.58789 10.375 3.58789 9.99998V1.46873C3.58789 1.08123 3.71914 0.756226 3.98164 0.493726C4.24414 0.231226 4.56289 0.0999756 4.93789 0.0999756H11.2191C11.6066 0.0999756 11.9316 0.231226 12.1941 0.493726C12.4566 0.756226 12.5879 1.08123 12.5879 1.46873V9.99998C12.5879 10.375 12.4566 10.6937 12.1941 10.9562C11.9316 11.2187 11.6066 11.35 11.2191 11.35H4.93789ZM4.93789 10.225H11.2191C11.2816 10.225 11.3379 10.203 11.3879 10.159C11.4379 10.1155 11.4629 10.0625 11.4629 9.99998V1.46873C11.4629 1.40623 11.4379 1.34998 11.3879 1.29998C11.3379 1.24998 11.2816 1.22498 11.2191 1.22498H4.93789C4.87539 1.22498 4.82239 1.24998 4.77889 1.29998C4.73489 1.34998 4.71289 1.40623 4.71289 1.46873V9.99998C4.71289 10.0625 4.73489 10.1155 4.77889 10.159C4.82239 10.203 4.87539 10.225 4.93789 10.225Z" fill="white" />
                            </svg></button>
                            <button onClick={() => { navigator.clipboard.writeText(window?.location?.href); toast?.success("Copied To Clipboard") }} data-aos="flip-up" className='rounded-[50%] border border-white p-3 sm:p-4'>  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.5 15.5C10.875 15.5 10.3437 15.2812 9.90625 14.8438C9.46875 14.4063 9.25 13.875 9.25 13.25C9.25 13.1625 9.25625 13.0717 9.26875 12.9777C9.28125 12.8842 9.3 12.8 9.325 12.725L4.0375 9.65C3.825 9.8375 3.5875 9.98425 3.325 10.0902C3.0625 10.1967 2.7875 10.25 2.5 10.25C1.875 10.25 1.34375 10.0312 0.90625 9.59375C0.46875 9.15625 0.25 8.625 0.25 8C0.25 7.375 0.46875 6.84375 0.90625 6.40625C1.34375 5.96875 1.875 5.75 2.5 5.75C2.7875 5.75 3.0625 5.803 3.325 5.909C3.5875 6.0155 3.825 6.1625 4.0375 6.35L9.325 3.275C9.3 3.2 9.28125 3.11575 9.26875 3.02225C9.25625 2.92825 9.25 2.8375 9.25 2.75C9.25 2.125 9.46875 1.59375 9.90625 1.15625C10.3437 0.71875 10.875 0.5 11.5 0.5C12.125 0.5 12.6563 0.71875 13.0938 1.15625C13.5312 1.59375 13.75 2.125 13.75 2.75C13.75 3.375 13.5312 3.90625 13.0938 4.34375C12.6563 4.78125 12.125 5 11.5 5C11.2125 5 10.9375 4.94675 10.675 4.84025C10.4125 4.73425 10.175 4.5875 9.9625 4.4L4.675 7.475C4.7 7.55 4.71875 7.63425 4.73125 7.72775C4.74375 7.82175 4.75 7.9125 4.75 8C4.75 8.0875 4.74375 8.178 4.73125 8.2715C4.71875 8.3655 4.7 8.45 4.675 8.525L9.9625 11.6C10.175 11.4125 10.4125 11.2655 10.675 11.159C10.9375 11.053 11.2125 11 11.5 11C12.125 11 12.6563 11.2188 13.0938 11.6562C13.5312 12.0937 13.75 12.625 13.75 13.25C13.75 13.875 13.5312 14.4063 13.0938 14.8438C12.6563 15.2812 12.125 15.5 11.5 15.5ZM11.5 3.5C11.7125 3.5 11.8905 3.42825 12.034 3.28475C12.178 3.14075 12.25 2.9625 12.25 2.75C12.25 2.5375 12.178 2.35925 12.034 2.21525C11.8905 2.07175 11.7125 2 11.5 2C11.2875 2 11.1095 2.07175 10.966 2.21525C10.822 2.35925 10.75 2.5375 10.75 2.75C10.75 2.9625 10.822 3.14075 10.966 3.28475C11.1095 3.42825 11.2875 3.5 11.5 3.5ZM2.5 8.75C2.7125 8.75 2.89075 8.678 3.03475 8.534C3.17825 8.3905 3.25 8.2125 3.25 8C3.25 7.7875 3.17825 7.60925 3.03475 7.46525C2.89075 7.32175 2.7125 7.25 2.5 7.25C2.2875 7.25 2.10925 7.32175 1.96525 7.46525C1.82175 7.60925 1.75 7.7875 1.75 8C1.75 8.2125 1.82175 8.3905 1.96525 8.534C2.10925 8.678 2.2875 8.75 2.5 8.75ZM11.5 14C11.7125 14 11.8905 13.928 12.034 13.784C12.178 13.6405 12.25 13.4625 12.25 13.25C12.25 13.0375 12.178 12.8595 12.034 12.716C11.8905 12.572 11.7125 12.5 11.5 12.5C11.2875 12.5 11.1095 12.572 10.966 12.716C10.822 12.8595 10.75 13.0375 10.75 13.25C10.75 13.4625 10.822 13.6405 10.966 13.784C11.1095 13.928 11.2875 14 11.5 14Z" fill="white" />
                            </svg></button>
                        </div>

                        <div className='flex w-full justify-end md:w-auto gap-8 mb-4 md:absolute md:top-[85%]  '>
                            <button
                                onClick={() => {
                                    ChangePage(currentPage, "decrement")
                                }}
                                className='rounded-[50%]  shadow-md bg-white p-3 sm:p-4' ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 15.625L9.075 14.55L3.25 8.75H15.625V7.25H3.25L9.075 1.45L8 0.375L0.375 8L8 15.625Z" fill="#1C1B1F" />
                                </svg></button>
                            <button onClick={() => {
                                ChangePage(currentPage, "increment")
                            }} className='rotate-180 md:ml-32    rounded-[50%] shadow-md bg-white p-3 sm:p-4' ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 15.625L9.075 14.55L3.25 8.75H15.625V7.25H3.25L9.075 1.45L8 0.375L0.375 8L8 15.625Z" fill="#1C1B1F" />
                                </svg></button>
                        </div>
                    </div>
                </div>

                <div className=' px-5 md:px-10 lg:px-20 py-14 flex gap-2'>
                    <div className=' w-1/4 hidden md:block'>
                        <div className='font-custom font-bold text-black-75  w-full text-base ' >
                            Recent Updates
                        </div>
                        {BlogPage?.sort((a: any, b: any) => { return b?.attributes?.BlogHeader?.Date.split("/")[2] - a?.attributes?.BlogHeader?.Date.split("/")[2] }).filter((node: any, index: number) => index < 5).map((node: any, index: number) => {
                            console.log("nakbbsadfjbh", node)
                            return (
                                <div className='w-full  text-black-75 text-sm my-4 p-4 border-l border-[#F7941E]'>
                                    <div className='flex items-center gap-2'>
                                        <svg width="14" height="13" viewBox="0 0 14 13" className='stroke-[#8A8A8A]' fill="#8A8A8A" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.31699 9.51669L10.017 8.81669L7.50033 6.30002V3.16669H6.50033V6.70002L9.31699 9.51669ZM7.00033 12.8334C6.12255 12.8334 5.29766 12.6667 4.52566 12.3334C3.75321 12 3.08366 11.55 2.51699 10.9834C1.95033 10.4167 1.50033 9.74713 1.16699 8.97469C0.833659 8.20269 0.666992 7.3778 0.666992 6.50002C0.666992 5.62224 0.833659 4.79713 1.16699 4.02469C1.50033 3.25269 1.95033 2.58335 2.51699 2.01669C3.08366 1.45002 3.75321 1.00002 4.52566 0.666687C5.29766 0.333354 6.12255 0.166687 7.00033 0.166687C7.8781 0.166687 8.70321 0.333354 9.47566 0.666687C10.2477 1.00002 10.917 1.45002 11.4837 2.01669C12.0503 2.58335 12.5003 3.25269 12.8337 4.02469C13.167 4.79713 13.3337 5.62224 13.3337 6.50002C13.3337 7.3778 13.167 8.20269 12.8337 8.97469C12.5003 9.74713 12.0503 10.4167 11.4837 10.9834C10.917 11.55 10.2477 12 9.47566 12.3334C8.70321 12.6667 7.8781 12.8334 7.00033 12.8334ZM7.00033 11.8334C8.4781 11.8334 9.73655 11.314 10.7757 10.2754C11.8143 9.23624 12.3337 7.9778 12.3337 6.50002C12.3337 5.02224 11.8143 3.7638 10.7757 2.72469C9.73655 1.68602 8.4781 1.16669 7.00033 1.16669C5.52255 1.16669 4.26433 1.68602 3.22566 2.72469C2.18655 3.7638 1.66699 5.02224 1.66699 6.50002C1.66699 7.9778 2.18655 9.23624 3.22566 10.2754C4.26433 11.314 5.52255 11.8334 7.00033 11.8334Z" fill="white" />
                                        </svg>
                                        {node?.attributes?.BlogHeader?.Date}
                                    </div>
                                    <div
                                        onClick={() => { handleSideBarClick(node) }}

                                        role='button' className='text-base font-bold'>
                                        {node?.attributes?.BlogHeader?.MainTitle}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className='w-full font-custom text-black-75 ' >
                        <img className='w-max h-auto mx-auto' alt={currentPage?.attributes?.BlogHeader?.MainTitle} src={`${env}${currentPage?.attributes?.BlogHeader?.Image?.data?.attributes?.url}`} />
                        {currentPage?.attributes?.BlogContent.map((node: any, index: number) => {
                            return (
                                <>
                                    {node?.DescriptionArray.map((innerNode: any, i: number) => {
                                        return (<>
                                            <div className='text-black-75 text-3xl font-bold' >
                                                {innerNode?.Title}
                                            </div>

                                            <div className='text-base font-bold my-4'>
                                                {innerNode?.Subtitle}
                                            </div>
                                            <div className='text-base font-normal my-4'>
                                                <div dangerouslySetInnerHTML={{ __html: innerNode?.Description }}></div>
                                            </div>
                                        </>)
                                    })}


                                </>

                            )
                        })}


                    </div>
                </div>
            </div>
            :
            <Loader />






    )
}

export default IndividualBlog